const API = {
  LOG_IN: "/company/login",
  ADMIN_LOG_IN: "/admin/company-login",
  FORGOT_PASSWORD: "/forgot_password",
  PROFILE: "/company/user_details",
  INVITATION: "/company/authentication_details",
  MASTER_PROFILE: "/company/profile",
  GET_DEPARTMENTS: "/company/departments",
  GET_COUNTRIES: "/country",
  GET_QUOTE: "/get_quote",
  UPGRADE_PLAN: "/upgrade",

  GET_CHECK_IN_DASHBOARD: "/checkin/company-analytics",
  GET_CHECK_IN_MORE_INSIGHT: "/checkin/company-analytics/more-insights",
};

export default API;
